<template>
  <div>
    <div class="message_board"> <el-tabs v-model="activeTab" @tab-click="productTabClick">
        <el-tab-pane label="产品资料库" name="products">
          <el-row>
            <el-input v-model="productsKeywords" placeholder="请输入关键字" clearable
              style="width: 300px; margin-right: 10px;" @clear="queryProductsList(true)"></el-input>
            <el-button @click="queryProductsList(true)" icon="el-icon-search" circle title="查询"></el-button>
            <el-button @click="addProduct()" icon="el-icon-plus" circle title="新增"></el-button>
          </el-row>
          <br>
          <el-table :data="productsList" border style="width: 100%" height="650" v-loading="vLoading">
            <el-table-column prop="product_name" label="产品名称"></el-table-column>
            <el-table-column prop="cas" label="CAS NO."></el-table-column>
            <el-table-column prop="price" label="价格">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" placement="top"
                  v-if="scope.row.price != null && scope.row.price.length > 12">
                  <div slot="content" v-html="scope.row.price"></div>
                  <span>{{ scope.row.price.substring(0, 12) + '...' }}</span>
                </el-tooltip>
                <span v-else>{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="factory" label="报价工厂"></el-table-column>
            <el-table-column prop="contactor" label="联系人"></el-table-column>
            <el-table-column prop="contactor_ways" label="联系方式"></el-table-column>
            <el-table-column prop="status" label="状态" width="120"></el-table-column>
            <el-table-column prop="created_info" label="入库信息"></el-table-column>
            <el-table-column prop="updated_info" label="最近更新"></el-table-column>
            <el-table-column label="操作" width="120">
              <template v-slot="scope">
                <el-button type="primary" icon="el-icon-view" @click="editProduct(scope.row)" circle title="查看"></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagenation">
            <el-pagination background layout="total, sizes, prev, pager, next" :total="productsTotal"
              @size-change="changeProductsSize" @current-change="currentProductsChange" :page-sizes="[10, 20, 50, 100]"
              :page-size="productsSize">
            </el-pagination>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="供应商" name="suppliers">
          <el-row>
            <el-input v-model="suppliersKeywords" placeholder="请输入关键字" clearable
              style="width: 300px; margin-right: 10px;" @clear="querySuppliersList()"></el-input>
            <el-button type="primary" @click="querySuppliersList()" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="addSupplier()" icon="el-icon-plus">新增</el-button>
          </el-row>
          <br>
          <el-table :data="suppliersList" border style="width: 100%" height="650">
            <el-table-column prop="supplier_name" label="厂商名称"></el-table-column>
            <el-table-column prop="main_products" label="主营产品">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.main_products" placement="top"
                  v-if="scope.row.main_products != null && scope.row.main_products.length > 12">
                  <span>{{ scope.row.main_products.substring(0, 12) + '...' }}</span>
                </el-tooltip>
                <span v-else>{{ scope.row.main_products }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="contactor" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="电话"></el-table-column>
            <el-table-column prop="email" label="邮箱"></el-table-column>
            <el-table-column prop="in_cooperation" label="合作中">
              <template v-slot="scope">
                <el-switch v-model="scope.row.in_cooperation" active-color="#13ce66" inactive-color="#dedede"
                  @change="toggleSupplierInCooperation(scope.row)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template v-slot="scope">
                <el-button type="primary" icon="el-icon-view" @click="editSupplier(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagenation">
            <el-pagination background layout="total, sizes, prev, pager, next" :total="suppliersTotal"
              @size-change="changeSuppliersSize" @current-change="currentSuppliersChange"
              :page-sizes="[10, 20, 50, 100]" :page-size="suppliersSize">
            </el-pagination>
          </div>
        </el-tab-pane> -->
      </el-tabs>
      <!-- <el-dialog title="新建供应商" :visible.sync="addSupplierVisible" :close-on-click-modal="false">
        <el-form :model="addSupplierForm" label-width="100px" :rules="addSupplierRules" ref="addSupplierForm"
          v-loading="addSupplierLoading">
          <el-row>
            <el-col :span="12">
              <el-form-item label="厂商名称" prop="supplier_name">
                <el-input v-model="addSupplierForm.supplier_name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contactor">
                <el-input v-model="addSupplierForm.contactor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="电话" prop="phone">
                <el-input v-model="addSupplierForm.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="addSupplierForm.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="其他联系人" prop="other_contacts">
                <el-input type="textarea" v-model="addSupplierForm.other_contacts" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="主营产品" prop="main_products">
                <el-input type="textarea" v-model="addSupplierForm.main_products" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="厂址" prop="address">
                <el-input v-model="addSupplierForm.address"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelAddSupplier">取 消</el-button>
          <el-button type="primary" @click="comfirmAddSupplier">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="editSupplierTitle" :visible.sync="editSupplierVisible" :close-on-click-modal="false">
        <el-form :model="editSupplierForm" label-width="100px" :rules="editSupplierRules" ref="editSupplierForm"
          v-loading="editSupplierLoading">
          <el-row>
            <el-col :span="12">
              <el-form-item label="厂商名称" prop="supplier_name">
                <el-input v-model="editSupplierForm.supplier_name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contactor">
                <el-input v-model="editSupplierForm.contactor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="电话" prop="phone">
                <el-input v-model="editSupplierForm.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="editSupplierForm.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="其他联系人" prop="other_contacts">
                <el-input type="textarea" v-model="editSupplierForm.other_contacts" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="主营产品" prop="main_products">
                <el-input type="textarea" v-model="editSupplierForm.main_products" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="厂址" prop="address">
                <el-input v-model="editSupplierForm.address"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editSupplierVisible = false">取 消</el-button>
          <el-button type="primary" @click="comfirmEditSupplier">确 定</el-button>
        </div>
      </el-dialog> -->
      <el-dialog title="产品入库" :visible.sync="addProductVisible" :close-on-click-modal="false"
        style="margin-top: -90px;">
        <el-form :model="addProductForm" label-width="100px" :rules="addProductRules" ref="addProductForm"
          v-loading="addProductLoading">
          <el-row>
            <el-col :span="12">
              <el-form-item label="产品名称" prop="product_name">
                <el-input v-model="addProductForm.product_name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="CAS NO." prop="cas">
                <el-input v-model="addProductForm.cas"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="状态">
                <el-select v-model="addProductForm.status" style="width: 100%">
                  <el-option v-for="item in productStatus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="价格" prop="price">
                <el-input type="textarea" v-model="addProductForm.price" rows="4"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="报价工厂" prop="factory">
                <el-input v-model="addProductForm.factory"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contactor">
                <el-input v-model="addProductForm.contactor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="联系方式" prop="contactor_ways">
                <el-input type="textarea" v-model="addProductForm.contactor_ways" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="报价格式" prop="quotation_format">
                <el-input type="textarea" v-model="addProductForm.quotation_format" rows="10"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="补充说明" prop="memo">
                <el-input type="textarea" v-model="addProductForm.memo" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelAddProduct">取 消</el-button>
          <el-button type="primary" @click="comfirmAddProduct">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="editProductTitle" :visible.sync="editProductVisible" :close-on-click-modal="false"
        style="margin-top: -90px;">
        <el-form :model="editProductForm" label-width="100px" :rules="editProductRules" ref="editProductForm"
          v-loading="editProductLoading">
          <el-row>
            <el-col :span="12">
              <el-form-item label="产品名称" prop="product_name">
                <el-input v-model="editProductForm.product_name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="CAS NO." prop="cas">
                <el-input v-model="editProductForm.cas"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="状态">
                <el-select v-model="editProductForm.status" style="width: 100%">
                  <el-option v-for="item in productStatus" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="价格" prop="price">
                <el-input type="textarea" v-model="editProductForm.price" rows="4"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="报价工厂" prop="factory">
                <el-input v-model="editProductForm.factory"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人" prop="contactor">
                <el-input v-model="editProductForm.contactor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="联系方式" prop="contactor_ways">
                <el-input type="textarea" v-model="editProductForm.contactor_ways" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="报价格式" prop="quotation_format">
                <el-input type="textarea" v-model="editProductForm.quotation_format" rows="10"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="补充说明" prop="memo">
                <el-input type="textarea" v-model="editProductForm.memo" rows="2"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editProductVisible = false">取 消</el-button>
          <el-button type="primary" @click="comfirmEditProduct">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Nav from '../Global/Nav.vue'
export default {
  name: 'MessageBoard',
  components: {
    Nav
  },
  data() {
    return {
      activeTab: 'products',
      vLoading: false,
      suppliersKeywords: '',
      suppliersList: [],
      suppliersTotal: 0,
      suppliersPage: 1,
      suppliersSize: 10,
      addSupplierVisible: false,
      addSupplierLoading: false,
      addSupplierForm: {
        supplier_name: null,
        contactor: null,
        phone: null,
        email: null,
        other_contacts: null,
        main_products: null,
        address: null
      },
      addSupplierRules: {
        supplier_name: [
          { required: true, message: '名称不能为空', trigger: 'commit' }
        ]
      },
      editSupplierTitle: '',
      editSupplierVisible: false,
      editSupplierLoading: false,
      editSupplierForm: {},
      editSupplierRules: {
        supplier_name: [
          { required: true, message: '名称不能为空', trigger: 'commit' }
        ]
      },
      productsKeywords: '',
      productsList: [],
      productsTotal: 0,
      productsPage: 1,
      productsSize: 10,
      addProductVisible: false,
      addProductLoading: false,
      addProductForm: {
        product_name: null,
        cas: null,
        price: null,
        factory: null,
        contactor: null,
        contactor_ways: null,
        quotation_format: `Hi xxx
Good day! Pls check us best price as below:
Product: xx
Package: In xx kg/bag,
Quantity: 1FCL,(xxMT per 20'FCL)
Price:
USDxx/MT FOB xx port, based on payment terms of xxx
Delivery: In xx ,2024
Validity of this offer: 3days`,
        status: 'A',
        memo: ''
      },
      addProductRules: {
        product_name: [
          { required: true, message: '名称不能为空', trigger: 'commit' }
        ]
      },
      editProductTitle: '',
      editProductVisible: false,
      editProductLoading: false,
      editProductForm: {},
      editProductRules: {
        product_name: [
          { required: true, message: '名称不能为空', trigger: 'commit' }
        ]
      },
      productStatus: []
    }
  },
  mounted() {
    this.init();
    this.queryProductsList();
  },
  methods: {
    async init() {
      await this.$axios.get(`/basic/products/options`).then((response) => {
        this.productStatus = response.data.data
      });
    },
    productTabClick(tab) {
      switch (tab.name) {
        case 'products':
          this.queryProductsList();
          break;
        case 'suppliers':
          this.querySuppliersList();
          break;
      }
    },
    querySuppliersList() {
      let current_page = this.suppliersPage;
      let keywords = this.suppliersKeywords;
      let size = this.suppliersSize;
      this.$axios.get('/basic/suppliers/list', {
        params: {
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.suppliersList = response.data.data.data;
          this.suppliersTotal = response.data.data.total;
        }
      })
    },
    changeSuppliersSize(val) {
      this.suppliersSize = val;
      this.querySuppliersList();
    },
    currentSuppliersChange(val) {
      this.suppliersPage = val;
      this.querySuppliersList();
    },
    addSupplier() {
      this.addSupplierVisible = true;
    },
    comfirmAddSupplier() {
      this.$refs.addSupplierForm.validate(valid => {
        if (valid) {
          this.addSupplierLoading = true;
          this.$axios.post('/basic/suppliers/save',
            this.addSupplierForm
          ).then(() => {
            this.querySuppliersList();
            this.addSupplierVisible = false;
            this.addSupplierLoading = false;
          })
          this.addSupplierForm = {
            supplier_name: null,
            contactor: null,
            phone: null,
            email: null,
            other_contacts: null,
            main_products: null,
            address: null
          }
        }
      })
    },
    cancelAddSupplier() {
      this.addSupplierVisible = false;
      this.addSupplierForm = {
        supplier_name: null,
        contactor: null,
        phone: null,
        email: null,
        other_contacts: null,
        main_products: null,
        address: null
      }
    },
    editSupplier(row) {
      this.editSupplierTitle = row.supplier_name;
      this.editSupplierVisible = true;
      this.editSupplierForm = row;
    },
    comfirmEditSupplier() {
      this.$refs.editSupplierForm.validate(valid => {
        if (valid) {
          this.editSupplierLoading = true;
          this.$axios.post('/basic/suppliers/save',
            this.editSupplierForm
          ).then(() => {
            this.querySuppliersList();
            this.editSupplierVisible = false;
            this.editSupplierLoading = false;
          })
          this.editSupplierForm = {
            supplier_name: null,
            contactor: null,
            phone: null,
            email: null,
            other_contacts: null,
            main_products: null,
            address: null
          }
        }
      })
    },
    toggleSupplierInCooperation(row) {
      this.$axios.post('basic/suppliers/toggle_cooperation', {
        id: row.id,
        in_cooperation: row.in_cooperation
      }).then((response) => {
        if (response.data.code === 200) {
          // this.getEmailAccountsOptions();
        } else {
          row.in_cooperation = !row.in_cooperation
          this.$notify({
            title: 'failed',
            message: response.data.data,
            type: 'error'
          })
        }
      })
    },
    queryProductsList(search = false) {
      this.vLoading = true;
      let current_page = search === true ? 1 : this.productsPage;
      let keywords = this.productsKeywords;
      let size = this.productsSize;
      this.$axios.get('/basic/products/list', {
        params: {
          keywords: keywords,
          page: current_page,
          size: size
        }
      }).then((response) => {
        this.vLoading = false;
        if (response.data.code === 200) {
          this.productsList = response.data.data.data;
          this.productsTotal = response.data.data.total;
        }
      })
    },
    changeProductsSize(val) {
      this.productsSize = val;
      this.queryProductsList();
    },
    currentProductsChange(val) {
      this.productsPage = val;
      this.queryProductsList();
    },
    addProduct() {
      this.addProductVisible = true;
      this.$axios.get(`/basic/suppliers/selection`).then((response) => {
        this.suppliersList = response.data.data
      })
    },
    comfirmAddProduct() {
      this.$refs.addProductForm.validate(valid => {
        if (valid) {
          this.addProductLoading = true;
          this.$axios.post('/basic/products/save',
            this.addProductForm
          ).then(() => {
            this.queryProductsList();
            this.addProductVisible = false;
            this.addProductLoading = false;
          })
          this.addProductForm = {
            product_name: null,
            cas: null,
            price: null,
            factory: null,
            contactor: null,
            contactor_ways: null,
            quotation_format: `Hi xxx
Good day! Pls check us best price as below:
Product: xx
Package: In xx kg/bag,
Quantity: 1FCL,(xxMT per 20'FCL)
Price:
USDxx/MT FOB xx port, based on payment terms of xxx
Delivery: In xx ,2024
Validity of this offer: 3days`,
            status: 'A'
          }
        }
      })
    },
    cancelAddProduct() {
      this.addProductVisible = false;
      this.addProductForm = {
        product_name: null,
        cas: null,
        price: null,
        factory: null,
        contactor: null,
        contactor_ways: null,
        quotation_format: `Hi xxx
Good day! Pls check us best price as below:
Product: xx
Package: In xx kg/bag,
Quantity: 1FCL,(xxMT per 20'FCL)
Price:
USDxx/MT FOB xx port, based on payment terms of xxx
Delivery: In xx ,2024
Validity of this offer: 3days`,
        status: 'A'
      }
    },
    editProduct(row) {
      this.editProductTitle = row.product_name;
      this.editProductVisible = true;
      this.$axios.get(`/basic/suppliers/selection`).then((response) => {
        this.suppliersList = response.data.data
      })
      this.$axios.get(`/basic/products/detail?id=${row.id}`).then((response) => {
        this.editProductForm = response.data.data;
      })
    },
    comfirmEditProduct() {
      this.$refs.editProductForm.validate(valid => {
        if (valid) {
          this.editProductLoading = true;
          this.$axios.post('/basic/products/save',
            this.editProductForm
          ).then(() => {
            this.queryProductsList();
            this.editProductVisible = false;
            this.editProductLoading = false;
          })
          this.editProductForm = {
          }
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Modules/Products.vue